import template from './previous-search.html';

const DIRECTIVE_NAME = PreviousSearch.DIRECTIVE_NAME = 'ktPreviousSearch';
export default function PreviousSearch() {
    return {
        restrict: 'E',
        scope: {
            results: `=${DIRECTIVE_NAME}Results`,
            onRepeatSearch: `=${DIRECTIVE_NAME}OnRepeatSearch`,
            type: `@${DIRECTIVE_NAME}Type`,
        },
        controller: PreviousSearchController,
        controllerAs: 'previousSearchCtrl',
        template,
        bindToController: true,
        link: function($scope, elem, attrs, previousSearchCtrl) {
            previousSearchCtrl.$onInit();
        },
    };
}

export function PreviousSearchController(
    previousSearchService,
    l10nService,
    userService,
    moment,
) {
    'ngInject';
    const vm = this;
    const MIN_NUMBER_PREVIOUS_SEARCHES = 2;
    const INITIAL_PREVIOUS_SEARCH_COUNT = 3;
    const EXTENDED_PREVIOUS_SEARCH_COUNT = 10;

    Object.assign(vm, {
        $onInit,
        showMore,
        isLoadMoreVisible,
        getLoadMoreLinkTranslation,
        isMinimizedView: true,
        l10nService,
        moment,
    });

    function $onInit() {
        vm.regionalSettings = userService.getRegionalSettings();
        vm.previousSearchLimit = INITIAL_PREVIOUS_SEARCH_COUNT;
        vm.getFormattedDate = previousSearchService.getFormattedDate;
    }

    function showMore() {
        vm.isMinimizedView = !vm.isMinimizedView;
        vm.previousSearchLimit = vm.isMinimizedView ? INITIAL_PREVIOUS_SEARCH_COUNT : EXTENDED_PREVIOUS_SEARCH_COUNT;
    }

    function isLoadMoreVisible() {
        return vm.results.length > MIN_NUMBER_PREVIOUS_SEARCHES;
    }

    function getLoadMoreLinkTranslation() {
        return vm.isMinimizedView
            ? l10nService.localize('See more searches')
            : l10nService.localize('See less searches');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/previous-search/previous-search-component.js